/* import __COLOCATED_TEMPLATE__ from './selected-choice.hbs.js'; */
import Component from "@ember/component";
import { computed } from "@ember/object";
import { guidFor } from "@ember/object/internals";
import { tagName } from "@ember-decorators/component";
import UtilsMixin from "select-kit/mixins/utils";
const SelectedChoice = dt7948.c(class SelectedChoice extends Component.extend(UtilsMixin) {
  item = null;
  selectKit = null;
  extraClass = null;
  id = null;
  init() {
    super.init(...arguments);
    this.set("id", guidFor(this));
  }
  get itemValue() {
    return this.getValue(this.item);
  }
  static {
    dt7948.n(this.prototype, "itemValue", [computed("item")]);
  }
  get itemName() {
    return this.getName(this.item);
  }
  static {
    dt7948.n(this.prototype, "itemName", [computed("item")]);
  }
  get mandatoryValuesArray() {
    return this.get("mandatoryValues")?.split("|") || [];
  }
  static {
    dt7948.n(this.prototype, "mandatoryValuesArray", [computed("item")]);
  }
  get readOnly() {
    if (typeof this.item === "string") {
      return this.mandatoryValuesArray.includes(this.item);
    }
    return this.mandatoryValuesArray.includes(this.item.id);
  }
  static {
    dt7948.n(this.prototype, "readOnly", [computed("item")]);
  }
}, [tagName("")]);
export default SelectedChoice;